import { render, staticRenderFns } from "./custom_pcb_ban.vue?vue&type=template&id=39188c10&scoped=true"
import script from "./custom_pcb_ban.vue?vue&type=script&lang=js"
export * from "./custom_pcb_ban.vue?vue&type=script&lang=js"
import style0 from "./custom_pcb_ban.vue?vue&type=style&index=0&id=39188c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39188c10",
  null
  
)

export default component.exports